export const SUPPORT_EMAIL = "driverresource@hived.space" as const;

